import React from 'react';
import { Alert, Modal, Typography } from 'antd';

const { Text } = Typography;

interface VerifyModalProps {
  open: boolean;
  formId: string | null;
  pagePath: string;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
  openBugCount?: number;
}

const VerifyModal: React.FC<VerifyModalProps> = ({
  open,
  formId,
  pagePath,
  onConfirm,
  onCancel,
  loading,
  openBugCount = 0,
}) => {
  const hasOpenBugs = openBugCount > 0;

  return (
    <Modal
      title="確認驗收完成"
      open={open}
      onOk={onConfirm}
      onCancel={onCancel}
      okText="確認通過"
      cancelText="稍後再驗"
      confirmLoading={loading}
      okButtonProps={{ type: 'primary', disabled: hasOpenBugs }}
    >
      <div style={{ padding: '16px 0' }}>
        {hasOpenBugs && (
          <Alert
            type="error"
            showIcon
            message={`目前還有 ${openBugCount} 筆待修復問題，請先確認修復完成後再驗收`}
            style={{ marginBottom: 16 }}
          />
        )}

        <p>
          驗收完成後，這個頁面已修復的回報會從「我的回報」移除；
          尚未修復的問題會繼續保留在清單中。
        </p>

        <div style={{ marginTop: 12, padding: 12, background: '#fafafa', borderRadius: 6 }}>
          <div>
            <Text type="secondary">頁面</Text>
            <Text strong style={{ marginLeft: 8 }}>{pagePath}</Text>
          </div>
          {formId && (
            <div style={{ marginTop: 4 }}>
              <Text type="secondary">模組</Text>
              <Text strong style={{ marginLeft: 8 }}>{formId}</Text>
            </div>
          )}
        </div>

        <p style={{ marginTop: 16, color: '#8c8c8c', fontSize: 13 }}>
          只有狀態為「待驗收」的回報，才會在這一步被標記為完成。
        </p>
      </div>
    </Modal>
  );
};

export default VerifyModal;
